import React from "react";
import Feature from "./Feature";

function Features() {

  return (
    <div className="py-12 bg-gray-100" data-aos="fade-up">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 my-2">
        <div className="lg:text-center">
          <h3 className="text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
            The ultimate template for your project
          </h3>
          <p className="mt-4 max-w-2xl text-xl font-body leading-7 text-gray-800 lg:mx-auto">
            Move fast with Tailwind while keeping your code production ready.
          </p>
        </div>

        <div className="mt-10">
          <ul className="md:grid md:grid-cols-2 md:col-gap-8 md:row-gap-10">
            {[
              {
                featureTitle: 'Reusable Components',
                featureText: 'Use our resusable components styled with Tailwind to easily change up your website.'
              },
              {
                featureTitle: 'Lightning Fast',
                featureText: 'Our templates are super lightweight and fast with almost perfect lighthouse scores.'
              },
              {
                featureTitle: 'Mobile Responsive',
                featureText: 'Templates are optimized for every size so you don\'t have to worry about things breaking.'
              },
              {
                featureTitle: 'Production Ready PWA',
                featureText: 'We take care of the annoying things like setting up service workers and purging extra CSS so your app is optimized for production.'
              },                                          
            ].map((item, index) => (
              <li key={index}>
                <Feature
                  featureTitle={item.featureTitle}
                  featureText={item.featureText}                  
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Features;